import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import ViewIcon from "components/CustomIcons/View.js";
import EmailIcon from "components/CustomIcons/Email.js";

import { Visibility, CreditCard } from "@material-ui/icons";
import DescriptionIcon from "@material-ui/icons/Description";
import EmailView from "@material-ui/icons/Email";

import { Tooltip } from "@material-ui/core";

import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import { useInactivity } from "components/Inactivity/Inactivity";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/CustomTable.js";
import CustomInput from "components/CustomInput/CustomOutlinedInput.js";
import Button from "components/CustomButtons/CustomButton";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import stylePrincipal from "assets/jss/material-dashboard-pro-react/components/principalStyle.js";
import CustomModal from "components/CustomModal/Modal.js";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";

import { getPoliciesByAgent } from "views/Services/OrdersService";
import { sendEmailAgent } from "views/Services/ClientService";
import { getTransactionsData, getTransactionDocument } from "views/Services/TransactionsService";
import CircularProgress from "@material-ui/core/CircularProgress";

import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import Chip from "@material-ui/core/Chip";

import MenuButton from "components/MenuButton/MenuButton.js";

import {
  checkIfIsKiosko,
  sanatizeMessageHtml,
} from "components/Utils/utils.js";
import environment from "../../environment/environment";
import { useTranslation } from "react-i18next";
const server = `${environment.SERVER}`;

const useStyles = makeStyles(styles);
const useStylesPrincipal = makeStyles(stylePrincipal);
export default function Dashboard() {
  const wizardRef = useRef(null);
  const { t, i18n } = useTranslation();
  const classesPrincipal = useStylesPrincipal();
  let USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  const isKiosko = checkIfIsKiosko();
  const history = useHistory();
  const dispatch = useDispatch();
  const [orders, setOrders] = useState([]);
  const [ordenes, setOrdenes] = useState([]);
  const isInactive = useInactivity();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));
  const isMd = useMediaQuery(theme.breakpoints.only("md"));
  const isLg = useMediaQuery(theme.breakpoints.only("lg"));
  const isXl = useMediaQuery(theme.breakpoints.only("xl"));
  const [totalRows, setTotalRows] = useState(0);
  const [currentOffset, setCurrentOffset] = useState(0);
  const [search, setSearch] = useState("");
  const [email, setEmail] = useState("");
  const [isAgent, setIsAgent] = useState(false);
  const [csrEmail, setCsrEmail] = useState("");
  const [loading, setLoading] = React.useState(false);
  const [downloadingDocument, setDownloadingDocument] = useState(null);
  const [downloadError, setDownloadError] = useState("");
  const downloadBusyRef = useRef(false);
  const rowsForPage = 10;
  const types = {
    1: "Policy",
    15: "Renewal",
    2: "Endorsement",
    3: "Cancellation",
    4: "Reinstatement",
    22: "Endorsement",
    23: "Endorsement",
    25: "Endorsement",
  };

  const styleButton = {
    cursor: "pointer",
    padding: "0px !important",
    textAlign: "center",
  };

  useEffect(() => {
    getPolicies(currentOffset);
  }, [dispatch]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setOrdenes([]);
      handleChangePage(0);
      goToFirstPage();
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [search]);

  const tableRef = useRef();

  const goToFirstPage = () => {
    tableRef.current.resetPage(0);
  };

  const goNext = () => {
    tableRef.current.nextPage();
  };

  const getPolicies = async (offset) => {
    setLoading(true);
    const data = {
      start: offset,
      length: 50,
      agent: isAgent,
      search: {
        value: search,
        regex: false,
      },
    };

    const resultSubmit = await dispatch(getTransactionsData(data));
    setOrdenes(resultSubmit.payload.data.data);
    setTotalRows(resultSubmit.payload.data.recordsFiltered);
    setCurrentOffset(offset);
    setLoading(false);
  };
  const classes = useStyles();

  // Hooks
  const redesign = process.env.REACT_APP_REDESIGN;
  const isRedesign = redesign === "true" ? true : false;
  const url = redesign === "true" ? "/guestRedesing" : "/admin/wizard";

  const handleFormChange = (event) => {
    const { name, value } = event.target;
    if (name === "search") {
      setSearch(value);
    }
    if (name === "email") {
      setSearch(value);
    }
    if (name === "csr") {
      setCsrEmail(value);
    }
  };
  const handleChangePage = (currentPage) => {
    if ((currentPage * rowsForPage) % 50 === 0) {
      getPolicies(currentPage * rowsForPage);
    }
  };

  const getStatusChip = (value) => {
    if (value === "0") {
      return (
        <Chip
          label="Pending"
          style={{ backgroundColor: "#ff9800", color: "#fff" }}
        />
      );
    } else if (value === "2") {
      return (
        <Chip
          label="Success"
          style={{ backgroundColor: "#4caf50", color: "#fff" }}
        />
      );
    } else if (value === "null" || value === null) {
      return (
        <Chip
          label="No relation found"
          style={{ backgroundColor: "#2196f3", color: "#fff" }}
        />
      );
    } else {
      return (
        <Chip
          label="Error"
          style={{ backgroundColor: "#f44336", color: "#fff" }}
        />
      );
    }
  };

  const downloadJson = (jsonObj, fileName) => {
    const blob = new Blob([typeof jsonObj === "string" ? jsonObj : JSON.stringify(jsonObj, null, 2)], {
      type: "application/json",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = fileName + ".json";
    link.click();

    URL.revokeObjectURL(url);
  };
  const getDocumentPdf = (base64String, fileName) => {
    const linkSource = `data:application/pdf;base64,${base64String}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName + ".pdf";
    downloadLink.click();
  };

  const downloadTransaction = async (row, source, format) => {
    if (downloadBusyRef.current) return;
    const key = `${row.id}:${row.hdi_transaction_id || ""}:${source}:${format}`;
    downloadBusyRef.current = true;
    setDownloadingDocument(key);
    setDownloadError("");
    try {
      const result = await dispatch(getTransactionDocument({
        transaction_id: row.id,
        hdi_transaction_id: row.hdi_transaction_id,
        source,
        format,
      })).unwrap();
      if (!result.result || !result.data?.[format]) {
        setDownloadError(result.message || "Document unavailable. Please try again.");
        return;
      }
      if (format === "pdf") {
        getDocumentPdf(result.data.pdf, `policy_${row.policy_nbr}${source === "hdi" ? "_hdi" : ""}`);
      } else {
        downloadJson(result.data.json, `${source === "hdi" ? "jsonHdi" : "received"}_${row.policy_nbr}`);
      }
    } catch (error) {
      setDownloadError("Unable to download document. Please try again.");
    } finally {
      downloadBusyRef.current = false;
      setDownloadingDocument(null);
    }
  };

  const documentButton = (row, source, format) => {
    const available = row[source === "hdi" ? `has_hdi_${format}` : `has_${format}`];
    if (!available) return "";
    const key = `${row.id}:${row.hdi_transaction_id || ""}:${source}:${format}`;
    return (
      <GridItem md={2} style={styleButton}>
        <Tooltip title={`Download ${format === "pdf" ? "Pdf" : "Json"}${source === "hdi" ? " Hdi" : ""}`} placement="top" arrow>
          <button
            type="button"
            aria-label={`Download ${format.toUpperCase()} ${row.policy_nbr}${source === "hdi" ? " HDI" : ""}`}
            disabled={downloadingDocument !== null}
            onClick={() => downloadTransaction(row, source, format)}
            style={{ border: 0, background: "transparent", padding: 0, cursor: downloadingDocument ? "wait" : "pointer" }}
          >
            {downloadingDocument === key ? (
              <CircularProgress size={18} />
            ) : (
              <CloudDownloadIcon style={{ color: "#13816F" }} fontSize="small" />
            )}
          </button>
        </Tooltip>
      </GridItem>
    );
  };

  const getActiveTransactions = () => {
    let rows = [];
    ordenes.forEach((row, index) => {
      const rowIndex = currentOffset + index;
      rows[rowIndex] = [
        row.policy_nbr,
        types[row.type],
        documentButton(row, "bluefire", "json"),
        documentButton(row, "hdi", "json"),
        row.created,
        row.datetosend,
        row.send_hdi,
        getStatusChip(row.status_hdi),
        documentButton(row, "bluefire", "pdf"),
        documentButton(row, "hdi", "pdf"),
      ];
    });
    return (
      <GridContainer>
        <GridItem xs={12} style={{ marginLeft: "20px" }}>
          {downloadError && <p role="alert" style={{ color: "#c62828" }}>{downloadError}</p>}
          <GridContainer style={{ marginBottom: "20px" }}>
            <GridItem xs={12}>
              <Table
                ref={tableRef}
                tableHead={[
                  "Policy Number",
                  "Transaction Type",
                  "JSON Received",
                  "JSON to HDI",
                  "Received Date",
                  "Date to send",
                  "Sended Date",
                  "Status",
                  "Policy",
                  "Policy Hdi",
                ]}
                tableData={rows}
                rowsPerPage={rowsForPage}
                totalRows={totalRows}
                changePage={handleChangePage}
                loading={loading}
              />
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    );
  };

  const gridPolicies = () => {
    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={12}>
            <GridContainer
              style={{ padding: "20px 0px 40px 0px" }}
              justify="center"
            >
              <GridContainer>
                <GridItem xs={12} md={12}>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <Card>
                      <CardHeader>
                        <div
                          className={`${classesPrincipal.title} ${classesPrincipal.black}`}
                        >
                          {"Transactions List"}
                        </div>
                        <GridContainer>
                          {ordenes && (
                            <>
                              <GridItem xs={12} style={{ marginTop: "15px" }}>
                                <GridContainer>
                                  <GridItem xs={0} sm={0} md={9}></GridItem>
                                  <GridItem xs={12} sm={12} md={3}>
                                    <CustomInput
                                      labelText={t("step2.search")}
                                      formControlProps={{
                                        fullWidth: true,
                                        className:
                                          classes.customFormControlClasses,
                                      }}
                                      inputProps={{
                                        name: "search",
                                        id: "search",
                                        value: search,
                                        onChange: handleFormChange,
                                      }}
                                    />
                                  </GridItem>
                                </GridContainer>
                              </GridItem>
                              <GridItem xs={12} style={{ marginTop: "15px" }}>
                                {getActiveTransactions()}
                              </GridItem>
                            </>
                          )}
                        </GridContainer>
                      </CardHeader>
                    </Card>
                  </GridItem>
                </GridItem>
              </GridContainer>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </div>
    );
  };

  return <>{gridPolicies()}</>;
}
